document.addEventListener("DOMContentLoaded", function () {
     const urlPath = window.location.pathname;
    const pathSegments = urlPath.split('/').filter(segment => segment); // Remove empty segments

    // Find the index of "collections" in the path
    const collectionsIndex = pathSegments.indexOf("collections");

    // Get the collection handle (next segment after "collections")
    const collectionHandle = (collectionsIndex !== -1 && pathSegments.length > collectionsIndex + 1) 
        ? pathSegments[collectionsIndex + 1] 
        : "";

    // Collections where the script should RUN
    const allowedCollections = ["verlobungsringe", "engagement-ring"];

    // Collections where the script should NOT run
    const excludedCollections = ["diamantringe"];

    // If the collection is in the excluded list, stop execution
    if (excludedCollections.includes(collectionHandle)) {
        return; // Do nothing
    }

    // If the collection is NOT in the allowed list, stop execution
    if (!allowedCollections.includes(collectionHandle)) {
        return; // Do nothing
    }
    
    const params = new URLSearchParams(window.location.search);    
    const style = params.get("style");
    const store_url = finalPageInfo.store_url;
    

    // Update Canonical URL
        let canonicalLink = document.querySelector('link[rel="canonical"]');
        if (!canonicalLink) {
            canonicalLink = document.createElement("link");
            canonicalLink.rel = "canonical";
            document.head.appendChild(canonicalLink);
      }
    canonicalLink.setAttribute("href", window.location.href);

    if(style){
      const formattedStyle = style.charAt(0).toUpperCase() + style.slice(1); // Capitalize first letter
      // Update Meta Description
      const metaDescription = document.querySelector('meta[name="description"]');
      
        // Update Meta Title
        if(formattedStyle =='Solitaire'){
          document.title = `${finalPageInfo.gemstoneMetaTitle_Solitaire}`; 
          if (metaDescription){
            metaDescription.setAttribute("content", `${finalPageInfo.gemstoneMetaDesc_Solitaire}`);
          }          
        }else if(formattedStyle =='Tension-Ring'){
          document.title = `${finalPageInfo.gemstoneMetaTitle_TensionRing}`;
          if (metaDescription){
            metaDescription.setAttribute("content", `${finalPageInfo.gemstoneMetaDesc_TensionRing}`);
          }
        }      
    }
});